import { useEffect } from "react";
import { useSelector } from "react-redux";
import { BuildTheme } from "../../../assests/global/Theme-variable";
import { IStoreState } from "../../../redux/store.types";


export const ThemeSettings = () => {
  const customizer = useSelector(
    (state: IStoreState) => state.customizer,
  );
  const theme = BuildTheme
  ({
    direction: customizer.activeDir,
    theme: customizer.activeTheme,
  });
  useEffect(() => {
    document.dir = customizer.activeDir;
  }, [customizer]);

  return theme;
};
